// extracted by mini-css-extract-plugin
export default {"iconWrapper":"vBef1pHpFZZ7EOkbwRLiY","icon":"jG4qV5SMdk4q-m9wTIiJt"};